import ReportRequest from 'Domain/ReportRequest';
import MockHelper from 'Support/helpers/MockHelper';

class RecebiveisRequest extends ReportRequest {
  static baseUrl() {
    return '/relatorios/recebiveis';
  }

  static generate() {
    return MockHelper.mockPromiseGetFileRequest();
  }
}

export default RecebiveisRequest;
